<template lang="pug">
.container
  .container-name(
    @click='toggleDesktopGroupSelected(desktopGroup, $event)',
    :class="{ selected: groupIsSelected }",
    @contextmenu='openRightClickGroupsMenu(desktopGroup, $event)'
  )
    .container-counter(
      @click.stop="$emit('showGroup', desktopGroup)", :title="$t('Open Group')"
    )
      .icon
        font-awesome-icon(icon="desktop")
      .desktops-count {{ desktopsInGroup.length }}
    .name {{ desktopGroup.name }} &nbsp;&nbsp;
    .muted {{ desktopGroup.address }}
    .expand(
      v-if='desktopsInGroup.length > 0'
      @click.stop="showGroupThumbnail = !showGroupThumbnail"
    )
      font-awesome-icon(:icon="showGroupThumbnail ? 'caret-down' : 'caret-right'")
    .cursor.edit-schedule(@dblclick="editScheduleVisible = true;", :title='$t("Edit group play schedule")')
      font-awesome-icon(icon="calendar-alt")
  .container-schedule(
    v-if='desktopGroup.DeviceDesktopGroup_DaytimeRestrictions.length > 0',
    :class="{ selected: groupIsSelected }"
  )
    ScheduleDateList(:id="'GroupRow'+desktopGroup.id+'-scheduleDateList'", :restrictions='desktopGroup.DeviceDesktopGroup_DateRestrictions')
    ScheduleDayTimeList(:id="'GroupRow'+desktopGroup.id+'-scheduleDayTimeList'", :restrictions='desktopGroup.DeviceDesktopGroup_DaytimeRestrictions', dayLabelLength='short')
  .container-thumbnail(v-if='showGroupThumbnail', @click.self="$refs.RightClickDesktopMenu.closeRightClickMenu()")
    .desktop(v-for="desktop in desktopsInGroup", :key="desktop.id", :id="'GroupRow'+desktopGroup.id+'-desktop'+desktop.id",
      @dragenter="dragEnterDesktop(desktop, $event)",
      :class="{ selected: desktopIsSelected(desktop) }",
      @click="toggleDesktopSelected(desktop, $event)",
      @contextmenu='openRightClickDesktopMenu(desktop, $event)'
    )
      .screenshot(:style="getScreenShotStyle(desktop)")
        .hb
          span.unhealthy(@dblclick="showEditDevice(desktop.Device)", v-if="!desktop.alive || desktop.HBTimestamp == '0'")
            font-awesome-icon(icon="medkit")
            span &nbsp; {{ humanDuration(Date.now() - desktop.updatedAt, 'rounded') }}
          span.healthy(v-else, @dblclick="showEditDevice(desktop.Device)")
            font-awesome-icon(icon="heartbeat")
          span.send-update.cursor-pointer(v-if="modificationExists(desktop)", @dblclick="sendContentUpdateRequest(desktop, $event)", :title="$t('Send content update to screen')")
            font-awesome-icon(icon="upload")
          span.send-update.cursor-pointer(v-if='contentDownload(desktop) && contentDownload(desktop).progress < 100',
              :class='{ muted: desktop.HBTimestamp == "0", danger: contentDownload(desktop).failed }'
            )
            font-awesome-icon.icon(icon="cloud-download-alt")
            span.no-wrap &nbsp; {{ Math.round(contentDownload(desktop).progress) }}%
      .descriptions
        p.desktop-description(@dblclick="showEditDevice(desktop.Device)") {{ fullNameOfDesktopPlaylist( localPlaylistsCache.find(lp => lp.id === desktop.LocalPlayList) ) }}
        p.playlist-description(@dblclick="showEditDevice(desktop.Device)") {{ formatLocalPlaylistContent(localPlaylistsCache.find(lp => lp.id === desktop.LocalPlayList)) }}
    el-dialog(v-if='editedDeviceId', :close-on-click-modal="false", title='', :visible.sync='editDeviceVisible', @close='closeEditDevice()', append-to-body, width='80%')
      EditDevice(v-if='editedDeviceId', :editedDeviceId='editedDeviceId')
  el-dialog(:close-on-click-modal="false", :visible.sync='editScheduleVisible', @close='editScheduleVisible = false', append-to-body, width='80%')
    h4.header-flex
      .name {{$t(`Edit group schedule for ${desktopGroup.name} - `)}}
        span.muted {{ desktopGroup.address }}
      .send-button(style='text-align:right')
        el-button(:id="'GroupRow'+desktopGroup.id+'-requestUpdateButton'", type='success', size='mini', @click='sendOnDemandScheduleRequest(true, desktopGroup)', :disabled='sendingOnDemandScheduleRequestsToGroup')
          font-awesome-icon(icon="upload")
          span(v-if='!sendingOnDemandScheduleRequestsToGroup') &nbsp; {{ $t('Send update schedule request to all devices in group') }}
          span(v-else) &nbsp; {{ $t('sending...') }}
    hr.header
    ScheduleDayTimeEditor(:id="'GroupRow'+desktopGroup.id+'-scheduleDayTimeEditor'", :item='desktopGroup', model='DeviceDesktopGroup')
    hr.header
    ScheduleDateEditor(:id="'GroupRow'+desktopGroup.id+'-scheduleDateEditor'", :item='desktopGroup', model='DeviceDesktopGroup')
  RightClickDesktopMenu(
    ref='RightClickDesktopMenu',
    @rightClickAction='rightClickAction',
  )
  ConfirmDialog(
    v-if='confirmDialogVisible',
    :confirmDialogVisible='confirmDialogVisible',
    :question='confirmDialogQuestion',
    :data='rightClickData',
    @confirmed='dialogConfirmed',
    @closed='dialogDenied'
  )
</template>

<script>

import Vue from 'vue'
import mediaUtils from '../Common/mediaUtils.mixin'
import textUtils from '../Common/textUtils.mixin'
import deviceUtils from '../Common/deviceUtils.mixin'
import deviceRCLCK from '../Common/deviceRCLCK.mixin'
import EditDevice from './AddEditDevice'
import ScheduleDayTimeEditor from '../Common/ScheduleDayTimeEditor'
import ScheduleDateEditor from '../Common/ScheduleDateEditor'
import ScheduleDayTimeList from '../Common/ScheduleDayTimeList'
import ScheduleDateList from '../Common/ScheduleDateList'
import RightClickDesktopMenu from './RightClickDesktopMenu'
import ConfirmDialog from '../Common/ConfirmDialog'

export default {
  mixins: [mediaUtils, textUtils, deviceUtils, deviceRCLCK],
  components: {
    EditDevice,
    ScheduleDayTimeEditor,
    ScheduleDateEditor,
    ScheduleDayTimeList,
    ScheduleDateList,
    RightClickDesktopMenu,
    ConfirmDialog
  },
  props: ['side', 'desktops', 'desktopGroup'],
  data () {
    return {
      errors: {
      },
      editedDeviceId: undefined,
      editDeviceVisible: false,
      editScheduleVisible: false,
      showGroupThumbnail: false,
      showGroupContextMenu: false,
      localPlaylistsCache: []
    }
  },
  async created () {
  },
  watch: {
    showGroupThumbnail: async function (newVal, oldVal) {
      if (newVal === true) {
        this.localPlaylistsCache = (await Vue.axios
          .get(`/medium?where={"id":{"in":${JSON.stringify(this.desktops.map(d => d.LocalPlayList))}}}&populate=PlayListItems`)).data
      }
    }
  },
  methods: {
    openRightClickGroupsMenu (desktopGroup, $event) {
      this.$emit('closeLeftPanelContextMenu')
      this.$emit('openRightClickGroupsMenu', { desktopGroup, $event })
    },
    openRightClickDesktopMenu (desktop, $event) {
      this.$emit('closeLeftPanelContextMenu')
      this.openRightClickMenu(desktop, $event)
    },
    showEditDevice (deviceId) {
      this.editedDeviceId = deviceId
      this.editDeviceVisible = true
      this.$store.dispatch('Device/clearDesktopsSelectedRight')
      const desktopInStore = this.$store.state.Device.desktop_list.find(dt => dt.Device === deviceId)
      this.$store.dispatch('Device/addDesktopsSelectedRight', [desktopInStore])
    },
    closeEditDevice () {
      this.editedDeviceId = undefined
      this.editDeviceVisible = false
    },
    closeRightClickDesktopMenu () {
      this.$refs.RightClickDesktopMenu.closeRightClickMenu()
    },
    showPlaylist (mediumId) {
      const medium = this.localPlaylistsCache.find(
        medium => medium.id === mediumId
      )
      if (!medium) return
      this.$emit('loadEditMediumInMediaEditor', medium)
      this.$store.dispatch('Medium/clearBreadcrumbs')
      this.$store.dispatch('Medium/addMediumIdToBreadcrumbs', medium.id)
    },
    getScreenShotStyle (desktop) {
      let height
      let width
      if (desktop.height >= desktop.width) {
        height = 190
        width = height * (desktop.width / desktop.height)
      } else {
        width = 190
        height = width * (desktop.height / desktop.width)
      }
      let screenshotURI = desktop.deviceDesktopScreenShotFilename
      if (desktop.deviceDesktopScreenShotFilename === '') {
        // screenshotURI = 'static/none2.png'
        screenshotURI = this.playListThumbnailById(desktop.LocalPlayList)
      }
      return `
        background-image: url(${!screenshotURI ? '' : screenshotURI});
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        width: ${width}px;
        height: ${height}px;
      `
    },
    // FIXME. Refreshes DOM only in direction Overdue => !Overdue
    overdueHB (desktop) {
      const desktopInStore = this.$store.state.Device.desktop_list.find(dt => dt.id === desktop.id)
      return ((Date.now() - desktopInStore.updatedAt) / 1000) > 60
    }
  },
  computed: {
    groupIsSelected () {
      return this.$store.state.Device.desktop_groups_selected_right.find(dg => dg.id === this.desktopGroup.id)
    },
    desktopsInGroup () {
      return this.$store.state.Device.desktop_list.filter(d => this.desktops.map(dsktp => dsktp.id).includes(d.id))
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.header-flex {
  display: flex;
  align-items: center;
  .send-button {
      margin-left: auto;
  }
}
.container {
  border: 0px solid red;
}
.container-name {
  &.selected {
     background-color: $--background-color-selected;
  }
  .edit-schedule {
    margin-left: auto
  }
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 5px;
  .expand {
    font-size: 20px;
    opacity: 0.4;
    margin-left: 30px;
  }
  .container-counter {
    position: relative;
    border: 0px solid grey;
    width: 50px;
    height: 50px;
    .icon, .desktops-count {
      margin: 0;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .icon {
      top: 56%;
      font-size: 30px;
      opacity: 0.2;
    }
  }
}
.container-thumbnail {
  color: $--color-text-secondary;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.container-schedule {
  display: flex;
  padding: 0px 0px 10px 0px;
  &.selected {
     background-color: $--background-color-selected;
  }
}
.desktop {
  width: 227px;
  height: 230px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1px;
  margin: 0px;
  // border: $--border-light;
  &.selected {
    background-color: $--background-color-selected;
    padding: 0px;
    margin: 1px;
  }
  .screenshot {
    border: $--border-light;
    position: relative;
    .hb {
      background-color: rgba($backgroundMainColor, 0.6);
      position: absolute;
      top: 0px;
      left: 0px;
      padding: 2px 0px;
      width:100%;
      .unhealthy, .healthy {
        margin-left:10px;
      }
      .unhealthy {
        color: #ff0000
      }
      .healthy {
        color: #00ff00
      }
      .send-update {
        float: right;
        margin-right: 10px;
      }
    }
  }
}
.descriptions {
  text-align: center;
  cursor: default;
  p {
    margin: 2px;
  }
  .playlist-description {
    color: $--color-warning;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Device/GroupRow.vue